import { render, staticRenderFns } from "./Stat.vue?vue&type=template&id=5a9b00cc&"
import script from "./Stat.vue?vue&type=script&lang=js&"
export * from "./Stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports